export default "__VITE_ASSET__fa5e45af__"